var _Array$isArray = require("@babel/runtime-corejs2/core-js/array/is-array");
function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/arrayWithHoles.js
// module id = 721
// module chunks = 101